// Fix invalid Shopify section names on cart API calls (e.g. Recharge sends "CartDrawer" instead of "cart-drawer").
(function fixCartApiSectionNames() {
  if (window.__starpowaCartFetchPatched) return;
  window.__starpowaCartFetchPatched = true;

  const SECTION_ALIASES = { CartDrawer: 'cart-drawer' };
  const nativeFetch = window.fetch.bind(window);

  function normalizeSectionNames(sectionsValue) {
    return String(sectionsValue).split(',').map((name) => {
      const trimmed = name.trim();
      return SECTION_ALIASES[trimmed] || trimmed;
    }).join(',');
  }

  function fixCartRequestUrl(url) {
    if (!url || url.indexOf('/cart/') === -1) return url;
    return url.replace(/([?&]sections=)([^&]+)/, (_, prefix, sections) => prefix + normalizeSectionNames(sections));
  }

  function fixCartRequestInit(init) {
    if (!init || !init.body || typeof init.body !== 'string') return init;
    try {
      const parsed = JSON.parse(init.body);
      if (!parsed.sections) return init;
      if (Array.isArray(parsed.sections)) {
        parsed.sections = parsed.sections.map((name) => SECTION_ALIASES[name] || name);
      } else {
        parsed.sections = normalizeSectionNames(parsed.sections);
      }
      return Object.assign({}, init, { body: JSON.stringify(parsed) });
    } catch (error) {
      return init;
    }
  }

  window.fetch = function (input, init) {
    let request = input;
    let requestInit = fixCartRequestInit(init);

    if (typeof input === 'string') {
      request = fixCartRequestUrl(input);
    } else if (input instanceof Request) {
      const fixedUrl = fixCartRequestUrl(input.url);
      if (fixedUrl !== input.url) {
        request = new Request(fixedUrl, input);
      }
    }

    return nativeFetch(request, requestInit);
  };
})();

// Beauty Bundle upsell popup — intercept Add to Cart before cart/add when metafield popup exists
(function initBeautyBundleUpsellPopup() {
  let bypass = false;
  let pendingTarget = null;

  function getPopup() {
    return document.getElementById('beauty-bundle-upsell-popup');
  }

  function openPopup(popup) {
    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add('is-open');
    document.documentElement.classList.add('beauty-bundle-upsell-open');
  }

  function closePopup(popup) {
    popup = popup || getPopup();
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('beauty-bundle-upsell-open');
  }

  function isMainProductAtcTarget(target) {
    if (!target || !target.closest) return null;
    if (target.closest('#beauty-bundle-upsell-popup')) return null;
    // Never intercept ATC / Add Bundle inside Quick Shop — keep its own cart flow intact
    if (target.closest('quick-add-modal')) return null;
    if (target.closest('cart-drawer') || target.closest('.cart-popup')) return null;
    if (target.closest('.promotional_product') || target.closest('.cart_promotion_banner')) return null;
    if (target.closest('.js-related-products-trigger') || target.closest('.related-product-section-cart-btn')) return null;
    if (target.closest('.subscribe-button-soldout')) return null;

    const collapseBtn = target.closest('.collapse_add_button') || target.closest('.collapsible-add-button');
    if (collapseBtn) return collapseBtn;

    const subscribeBtn = target.closest('.subscribe-button');
    if (subscribeBtn && !subscribeBtn.classList.contains('subscribe-button-soldout')) return subscribeBtn;

    const addtocartBtn = target.closest('button.addtocart');
    if (addtocartBtn) return addtocartBtn;

    const submitBtn = target.closest('[type="submit"]');
    if (submitBtn && (submitBtn.closest('product-form') || submitBtn.closest('product-grid-form'))) {
      return submitBtn;
    }

    return null;
  }

  function resumePendingAtc() {
    const target = pendingTarget;
    pendingTarget = null;
    if (!target) return;
    bypass = true;
    try {
      target.click();
    } finally {
      // Keep bypass long enough for triggerRelatedButton → subscribe/one-time re-clicks
      setTimeout(function () {
        bypass = false;
      }, 1500);
    }
  }

  function resolveUpsellSellingPlanId(popup) {
    const plan30 = popup.getAttribute('data-selling-plan-id-30') || '';
    const plan90 = popup.getAttribute('data-selling-plan-id-90') || '';
    const planDefault = popup.getAttribute('data-selling-plan-id') || plan30 || plan90 || '';

    let planLabel = '';
    let sellingPlanName = '';

    if (pendingTarget) {
      const planContainer = pendingTarget.closest('.collapsible-button') || pendingTarget.closest('.card_product_subscription') || pendingTarget.closest('.product');
      const subscribeBtn =
        (pendingTarget.classList && pendingTarget.classList.contains('subscribe-button') && pendingTarget) ||
        (planContainer && planContainer.querySelector('.subscribe-button')) ||
        null;
      const radio =
        (planContainer && planContainer.querySelector('input.select-plan:checked')) ||
        (planContainer && planContainer.querySelector('input[type="radio"]:checked')) ||
        document.querySelector('.collapsible_subscription_main.active input[type="radio"]') ||
        document.querySelector('input.select-plan:checked');

      planLabel = ((radio && radio.getAttribute('data-label')) || '').toLowerCase();
      sellingPlanName = (
        (subscribeBtn && subscribeBtn.getAttribute('data-selling-plan-name')) ||
        (radio && radio.getAttribute('data-selling-plan-name')) ||
        ''
      ).toLowerCase();
    }

    const activePlan = document.querySelector('.collapsible_subscription_main.active');
    if (activePlan && !planLabel && !sellingPlanName) {
      const radio = activePlan.querySelector('input[type="radio"]');
      const subscribeBtn = activePlan.querySelector('.subscribe-button');
      planLabel = ((radio && radio.getAttribute('data-label')) || '').toLowerCase();
      sellingPlanName = (
        (subscribeBtn && subscribeBtn.getAttribute('data-selling-plan-name')) ||
        (radio && radio.getAttribute('data-selling-plan-name')) ||
        ''
      ).toLowerCase();
    }

    const combined = `${planLabel} ${sellingPlanName}`.trim();
    const isQuarterly =
      combined.includes('90') ||
      combined.includes('3 month') ||
      combined.includes('quarterly') ||
      combined.includes('3 bundle') ||
      combined.includes('every 3');
    const isMonthly =
      !isQuarterly &&
      (combined.includes('30') || combined.includes('month') || combined.includes('monthly'));

    if (isQuarterly && plan90) return plan90;
    if (isMonthly && plan30) return plan30;
    if (planDefault) return planDefault;
    return plan30 || plan90 || '';
  }

  async function addUpsellToCart(popup, addButton) {
    const variantId = popup.getAttribute('data-upsell-variant-id');
    if (!variantId) return;

    if (addButton) addButton.classList.add('custom-loading');

    try {
      const item = {
        id: Number(variantId),
        quantity: 1,
      };
      const sellingPlanId = resolveUpsellSellingPlanId(popup);
      if (sellingPlanId) {
        item.selling_plan = Number(sellingPlanId);
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(item),
      });
      const data = await response.json();
      if (data.status) {
        alert(data.description || 'Unable to add Beauty Bundle to cart');
        return;
      }
      closePopup(popup);
      pendingTarget = null;
      if (typeof defaultCartDrawerUpdate === 'function') {
        await defaultCartDrawerUpdate(true);
      }
    } catch (error) {
      console.error('Beauty Bundle upsell add error:', error);
    } finally {
      if (addButton) addButton.classList.remove('custom-loading');
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const popup = getPopup();
      if (!popup) return;

      const dismissEl =
        event.target.closest('[data-beauty-bundle-upsell-close]') ||
        event.target.closest('[data-beauty-bundle-upsell-skip]');
      if (dismissEl && popup.contains(dismissEl)) {
        event.preventDefault();
        closePopup(popup);
        // Close / cancel → continue original ATC (main product only) and open cart drawer
        resumePendingAtc();
        return;
      }

      const addEl = event.target.closest('[data-beauty-bundle-upsell-add]');
      if (addEl && popup.contains(addEl)) {
        event.preventDefault();
        addUpsellToCart(popup, addEl);
        return;
      }

      if (bypass) return;
      if (popup.classList.contains('is-open')) return;

      const atcTarget = isMainProductAtcTarget(event.target);
      if (!atcTarget) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      pendingTarget = atcTarget;
      openPopup(popup);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const popup = getPopup();
      if (!popup || bypass || popup.classList.contains('is-open')) return;

      const form = event.target;
      if (!form || !form.closest) return;
      if (form.closest('cart-drawer') || form.closest('.cart-popup')) return;
      if (form.closest('quick-add-modal')) return;
      if (form.closest('.related-product-section-cart-btn')) return;

      const isProductAtcForm =
        form.closest('product-form') ||
        form.closest('product-grid-form') ||
        form.getAttribute('data-type') === 'add-to-cart-form';

      if (!isProductAtcForm) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      pendingTarget = form.querySelector('[type="submit"]') || form;
      openPopup(popup);
    },
    true
  );
})();

// --- Browser Details --- //
function getBroswerDetails() {
  //Checking the user's OS and Browser
  if ((navigator.userAgent).includes("Android")) {
    document.querySelector("html").classList.add("android");
  } else if ((navigator.userAgent).includes("Mac")) {
    document.querySelector("html").classList.add("mac");
  } else {
    document.querySelector("html").classList.add("windows");
  }
  //-- Browser --//
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  var isFirefox = typeof InstallTrigger !== 'undefined';
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
  })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;
  var isEdge = !isIE && !!window.StyleMedia;
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);
  var isBlink = (isChrome || isOpera) && !!window.CSS;
  if (isFirefox) {
    document.querySelector("html").classList.add("isFirefox")
  } else if (isChrome) {
    document.querySelector("html").classList.add("isChrome")
  } else if (isSafari) {
    document.querySelector("html").classList.add("isSafari")
  } else if (isOpera) {
    document.querySelector("html").classList.add("isOpera")
  } else if (isIE) {
    document.querySelector("html").classList.add("isIE")
  } else if (isEdge) {
    document.querySelector("html").classList.add("isEdge")
  } else if (isEdgeChromium) {
    document.querySelector("html").classList.add("isEdgeChromium")
  } else {
    document.querySelector("html").classList.add("isBlink")
  }
}
getBroswerDetails();



const menubaar = document.querySelector('.header__icon--menu');
const megamenu = document.querySelector(".megamenu_main_wrapper");
menubaar.addEventListener('click', (e) => {
  megamenu.classList.toggle("active");
  menubaar.classList.toggle("active");
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function cartPopupPos() {
  var cartPopup = document.querySelector('.cart-popup');
  var headerIconCart = document.querySelector('.header__icon--cart');

  if (cartPopup && window.innerWidth >= 768) {
    var l = headerIconCart.offsetLeft - cartPopup.offsetWidth + 20;
    var t = document.querySelector('header').offsetHeight;

    cartPopup.style.left = l + 'px';
    cartPopup.style.top = t + 'px';
  }
}

cartPopupPos();

// Subscription Icon
if (document.querySelector(".subscription-slider")) {
  var subscriptionSlider = new Flickity(".subscription-slider", {
    prevNextButtons: false,
    pageDots: true,
    cellAlign: 'left',
    contain: true
  });
}

// Update Subscription Details
function subscribeFooter(totalQuantity, original, price, saving) {
  var inCart = 0;
  var inCartTotal = 0;
  var inCartSavings = 0;
  document.querySelector('.subscription_add').disabled = true;

  fetch("{{ shop.secure_url }}/cart?view=subscription-count")
    .then(response => response.text())
    .then(res => {
      document.querySelector('.subscription_add').disabled = false;
      var ajaxObj = res.split('-');
      inCart = parseInt(ajaxObj[0]);
      inCartTotal = parseInt(ajaxObj[1]);
      inCartSavings = parseInt(ajaxObj[2]);
      var qRemainingClean = 3 - totalQuantity;

      if (price < 1) {
        price = price + inCartTotal;
      }
      if (saving < 1) {
        saving = saving + inCartSavings;
      }
      if (original < 1) {
        original = original + (price + saving);
      }
      if (totalQuantity < 1) {
        totalQuantity = totalQuantity + inCart;
      }

      document.querySelector('[data-total-quantity]').setAttribute('data-total-quantity', totalQuantity);
      document.getElementById('shopify-section-subscription-collection').querySelector('.subscribe-footer-atc .contents span').innerText = totalQuantity;

      var qRemainingClean = 3 - totalQuantity;

      var itemRemaining;
      var qRemaining = 3 - totalQuantity;
      var subscribeError = document.getElementById('shopify-section-subscription-collection').querySelector('.subscribe-tools .subscribe-error span');
      var subscribeBar = document.getElementById('shopify-section-subscription-collection').querySelector('.mob-fix .subscribe-error span');

      if (qRemainingClean == 3) {
        document.querySelector('.add-to-basket').classList.add('disabled');
      } else {
        document.querySelector('.add-to-basket').classList.remove('disabled');
      }
      if (qRemaining == 3) {
        itemRemaining = 'three';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      } else if (qRemaining == 2) {
        itemRemaining = 'two';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      } else if (qRemaining == 1) {
        itemRemaining = 'one';
        subscribeError.parentElement.style.display = 'block';
        subscribeError.parentElement.previousElementSibling.style.display = 'block';
        subscribeBar.parentElement.classList.remove("success");
      } else {
        subscribeError.parentElement.parentElement.classList.add('error-hide');
        subscribeError.parentElement.style.display = 'none';
        subscribeError.parentElement.previousElementSibling.style.display = 'none';
        subscribeBar.parentElement.classList.add("success");
      }
      subscribeBar.innerText = itemRemaining;
      subscribeError.innerText = itemRemaining;

      document.querySelector('.subscribe-footer-steps .subs-number.active').classList.remove('active');
      var subsNumbers = document.querySelectorAll('.subscribe-footer-steps .subs-number');
      for (var i = 0; i < totalQuantity; i++) {
        subsNumbers[i].classList.add('active');
      }

      document.querySelector('.subscribe-footer-totals .subtotal .money').setAttribute('data-amount', original);
      document.querySelector('.subscribe-footer-totals .subtotal .money').innerText = Shopify.formatMoney(original, document.body.getAttribute('data-format'));

      document.querySelector('.subscribe-footer-totals .saving .money').setAttribute('data-amount', saving);
      document.querySelector('.subscribe-footer-totals .saving .money').innerText = '-' + Shopify.formatMoney(saving, document.body.getAttribute('data-format'));

      if (price > 0) {
        document.querySelector('.subscribe-footer-totals .total .free-shipping').classList.add('show');
      } else {
        document.querySelector('.subscribe-footer-totals .total .free-shipping').classList.remove('show');
      }

      document.querySelector('.subscribe-footer-totals .total .money').setAttribute('data-amount', price);
      document.querySelector('.subscribe-footer-totals .total .money').innerText = Shopify.formatMoney(price, document.body.getAttribute('data-format'));
    })
    .catch(error => console.error('Error:', error));
}

// Add to basket click
if (document.getElementById('shopify-section-subscription-collection')) {
  document.getElementById('shopify-section-subscription-collection').querySelector('.add-to-basket').addEventListener('click', function () {
    this.classList.add('disabled');
    var defaultLabel = this.querySelector('.button-label').innerText;
    this.querySelector('.button-label').innerText = 'adding...';

    var product_array = [];
    document.querySelectorAll('.subscription_product.selected').forEach(function (element) {
      var variantID = element.getAttribute('data-variant');
      var variantQuantity = element.querySelector('.product-quantity__input').value;
      var variantComparePrice = element.querySelector('[data-compare-price]').getAttribute('data-compare-price');
      var item = {
        "variantID": variantID,
        "variantQuantity": variantQuantity,
        "variantComparePrice": variantComparePrice
        // "sellingPlan": sellingPlan
      };
      product_array.push(item);
    });

    document.querySelector('.loading-overlay').classList.add('visible');
    addAllItems(product_array);
  });
}

// Add all items
window.addAllItems = function addAllItems(array) {
  Shopify.queue = [];
  var totalQuantity = 0;
  let quantity = 0;

  if (isNaN(quantity)) {
    quantity = 0;
  }

  if (isNaN(totalQuantity)) {
    totalQuantity = 0;
  }
  array.forEach(data => {
    if (data.type === 'one') {
      Shopify.queue.push({
        variantId: data.variantID,
        variantQuantity: data.variantQuantity,
        type: 'one'
      });
    } else {
      console.log('One time variant added to cart');
      console.log(data.variantID);
      const variantBoxes = document.querySelectorAll('.variants-box');
      const hasAdditionalVariants = Array.from(variantBoxes).some(box => {
        const qtyInput = box.querySelector('.qty-numbers');
        return qtyInput && parseInt(qtyInput.value, 10) > 0;
      });
      const groupId = hasAdditionalVariants ? String(Date.now()) : null;

      // When additional variants have qty > 0, add only those—do not add the main product
      if (!hasAdditionalVariants) {
        if (Number(data.variantID) !== 42990971617369) {
          Shopify.queue.push({
            variantId: data.variantID,
            variantQuantity: data.variantQuantity,
            selling_plan: data.sellingplanid,
            property: data.property,
            subscriptionGroupId: groupId
          });
        } else {
          console.log("Skipped special variant:", data.variantID);
          // or call another function here
        }
      }

      variantBoxes.forEach(box => {
        const qtyInput = box.querySelector('.qty-numbers');
        if (!qtyInput) return;

        const qty = parseInt(qtyInput.value);
        console.log(qty)
        if (qty > 0) {
          const variantId = box.getAttribute('data-variant-id');
          // console.log(variantId);
          if (!variantId) return;

          Shopify.queue.push({
            variantId: variantId,
            variantQuantity: qty,
            type: 'one',
            subscriptionGroupId: groupId
          });
        }

      });
    }
  });
  Shopify.moveAlong = function () {

    if (Shopify.queue.length) {
      const request = Shopify.queue.shift();
      // totalQuantity += parseInt(request.variantQuantity);

      let data;
      // console.log(request.type);
      const groupId = request.subscriptionGroupId || null;
      if (request.type === 'one') { // One-time additional variants: pass "Additional Variant" property (same as Every Month/Quarterly)
        const properties = { "Additional Variant": "True" };
        if (groupId) properties._subscription_group_id = groupId;
        data = {
          id: Number(request.variantId) || request.variantId,
          quantity: Number(request.variantQuantity) || request.variantQuantity,
          properties: properties
        };
      } else { //console.log("else selling ID",request)
        data = {
          id: request.variantId,
          quantity: request.variantQuantity,
          selling_plan: request.selling_plan,
          properties: {
            __free_gift: request.property
          }
          // properties: {
          //   shipping_interval_frequency: request.frequency,
          //   shipping_interval_unit_type: request.unit_type,
          //   _compare_price: request.compare_price
          // }
        };
        if (groupId) {
          data.properties = data.properties || {};
          data.properties._subscription_group_id = groupId;
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then((res) => {
          Shopify.moveAlong();
          quantity += parseInt(request.variantQuantity);
        })
        .catch(() => {
          if (Shopify.queue.length) {
            Shopify.moveAlong();
          }
        });
    } else {
      defaultCartDrawerUpdate().then(function () {
        setTimeout(function () {
          if (typeof window.resetAdditionalProductQuantitiesAfterAddToCart === 'function') {
            window.resetAdditionalProductQuantitiesAfterAddToCart();
          }
        }, 500);
      });
      // addToCartOk(totalQuantity);
      cartUpdate('basic');
      // resetExpandWidget();
      resetPage();
    }
  }
  Shopify.moveAlong();
}

async function refreshCartDrawerSectionDom(openDrawer = true) {
  const response = await fetch(`${Shopify.routes.root}cart?section_id=cart-drawer`);
  const responseText = await response.text();
  const html = new DOMParser().parseFromString(responseText, 'text/html');
  const selector = ['cart-drawer'];
  const targetElement = document.querySelector(selector);
  const sourceElement = html.querySelector(selector);
  const isCartEmpty = sourceElement.classList.contains("is-empty");
  isCartEmpty ? targetElement.classList.add("is-empty") : targetElement.classList.remove("is-empty")
  targetElement.innerHTML = sourceElement.innerHTML;
  const res = await fetch(`${Shopify.routes.root}cart?section_id=cart-icon-bubble`);
  const resText = await res.text();
  const icon_bubble_html = new DOMParser().parseFromString(resText, 'text/html');
  const selector_bubble = ['#cart-icon-bubble'];
  const targetElement_bubble = document.querySelector(selector_bubble);
  const sourceElement_bubble = icon_bubble_html.querySelector('#shopify-section-cart-icon-bubble').innerHTML;

  if (targetElement_bubble && sourceElement_bubble) {
    targetElement_bubble.innerHTML = sourceElement_bubble;
  }
  if (openDrawer) {
    const cartDrawer = document.querySelector('cart-drawer');
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble && (!cartDrawer || !cartDrawer.classList.contains('active'))) {
      bubble.click();
    }
  }
}

async function defaultCartDrawerUpdate(openDrawer = true) {
  try {
    await refreshCartDrawerSectionDom(openDrawer);
    await syncFreeHydrationCheckoutRestriction();
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}

window.addEventListener("quizifyAddToCart", function () {
  defaultCartDrawerUpdate();
})

// After all items added
function addToCartOk(quantity) {
  // const addToBasketButton = document.querySelector('#shopify-section-subscription-collection .add-to-basket');
  // const buttonLabel = addToBasketButton.querySelector('.button-label');

  // buttonLabel.innerText = 'add subscription to basket';
  // addToBasketButton.classList.remove('disabled');
  cartUpdate('basic');
  cartBubble(quantity);
  resetPage();
}

//Cart Bubble
function cartBubble(quantity) {
  if (quantity > 0) {
    const cartCountBubble = document.querySelector('.cart-count-bubble');

    if (!cartCountBubble) {
      const cartIconBubble = document.querySelector('#cart-icon-bubble');
      const newCartCountBubble = document.createElement('div');
      newCartCountBubble.classList.add('cart-count-bubble');

      const firstSpan = document.createElement('span');
      firstSpan.setAttribute('aria-hidden', 'true');
      newCartCountBubble.appendChild(firstSpan);

      const secondSpan = document.createElement('span');
      secondSpan.classList.add('visually-hidden');
      newCartCountBubble.appendChild(secondSpan);

      cartIconBubble.appendChild(newCartCountBubble);
    }

    const firstSpan = document.querySelector('.cart-count-bubble span:first-child');
    firstSpan.innerText = quantity;

    const secondSpan = document.querySelector('.cart-count-bubble span:last-child');
    if (quantity > 1) {
      secondSpan.innerText = quantity + " items";
    } else {
      secondSpan.innerText = quantity + " item";
    }
  } else {
    const cartCountBubble = document.querySelector('.cart-count-bubble');
    if (cartCountBubble) {
      cartCountBubble.remove();
    }
  }
}

// Update Slideout Cart
async function cartUpdate(type) {
  const response = await fetch("/cart?view=ajax");
  const data = await response.text();

  if (response.ok) {
    document.body.classList.add('cart-open');
    const cartPopupInner = document.querySelector('.cart-popup-inner');
    if (cartPopupInner) {
      cartPopupInner.innerHTML = data;
    }
    const cartPopup = document.querySelector('.cart-popup');
    if (cartPopup) {
      cartPopup.classList.add('visible');
    }

    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const t = currentScrollTop - 1;
    window.scrollTo({ top: t, behavior: 'smooth' });

    const loadingOverlay = document.querySelector('.loading-overlay');
    if (loadingOverlay) { loadingOverlay.classList.remove('visible'); }
  }
}

/*
document.addEventListener('rebuy:cart.change', (event) => {
  const { cart: { cart: Smartcart} } = event.detail;
  setTimeout(()=>{
    const items = Smartcart.items;
    const allLiItems = document.querySelectorAll('.rebuy-cart__flyout-item');
    
    if (items.length > 0) {
      items.forEach((item, index) => {
        if(!allLiItems[index].hasAttribute('lineitem_sellingId')){        
          allLiItems[index]?.setAttribute('lineitem_sellingId', item?.selling_plan_allocation?.selling_plan?.id);
        }
      });
  
      const allQuarterlySubscriptionLi = document.querySelectorAll('[lineitem_sellingid]');
      if (allQuarterlySubscriptionLi.length > 0) {
        allQuarterlySubscriptionLi.forEach(quarterSubscriptionItem => {
          if(quarterSubscriptionItem?.getAttribute('lineitem_sellingid') === '1473806425'){          
            const quantityButtons = quarterSubscriptionItem?.querySelector('.rebuy-cart__flyout-item-quantity-widget')?.querySelectorAll('button');
            if(quantityButtons.length > 0){quantityButtons.forEach(button=> button.classList.add('hidden'))};
          }
        });
      }
    }
    const cartDrawerAnnouncementBar = document.querySelector('.rebuy-cart__flyout-announcement-bar-message');
    if(cartDrawerAnnouncementBar){    
      if(Smartcart.item_count === 0){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.cart_empty;
      } else if(Smartcart.item_count === 1){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.one_product_in_cart;
      } else if(Smartcart.item_count === 2){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.two_products_in_cart;   
      } else if(Smartcart.item_count > 2){
        cartDrawerAnnouncementBar.innerHTML = window.theme.cart_announcement_bar.three_products_or_more_in_cart;   
      }
    }
    if(document.querySelector('.cart-count-bubble span:first-child')){
      document.querySelector('.cart-count-bubble span:first-child').innerText = Smartcart.item_count;
    }  
  }, 100);
});
*/


// Reset page after add to basket
function resetPage() {

  const subscriptionLinkButtons = document.querySelectorAll('.subscription-link .subscribe-button');
  subscriptionLinkButtons.forEach(subscriptionLinkButton => {
    if (subscriptionLinkButton.classList.contains('custom-loading')) {
      subscriptionLinkButton.classList.remove('custom-loading');
    }
  });

  const productGridForms = document.querySelectorAll('product-grid-form [type="submit"]');
  productGridForms.forEach(productGridForm => {
    if (productGridForm.classList.contains('custom-loading')) {
      productGridForm.classList.remove('custom-loading');
    }
  });

  const productQuantityElements = document.querySelectorAll('#shopify-section-subscription-collection .product-quantity');
  productQuantityElements.forEach(productQuantityElement => {
    if (productQuantityElement) {
      productQuantityElement.classList.remove('show');
    }
  });

  const subscriptionAddElements = document.querySelectorAll('.subscription_add');
  subscriptionAddElements.forEach(subscriptionAddElement => {
    if (subscriptionAddElement) {
      subscriptionAddElement.classList.remove('added');
      const amountElement = subscriptionAddElement.querySelector('.amount');
      amountElement.innerText = '';
      const labelElement = subscriptionAddElement.querySelector('.label');
      labelElement.innerText = '&nbsp;add.';

      if (subscriptionAddElement.hasAttribute('disabled')) {
        const labelElement = subscriptionAddElement.querySelector('.label');
        labelElement.innerText = '&nbsp;soldout.';
      }
    }
  });

  const subscriptionProductElements = document.querySelectorAll('.subscription_product');
  subscriptionProductElements.forEach(subscriptionProductElement => {
    if (subscriptionProductElement) {
      subscriptionProductElement.classList.remove('selected');
      const productQuantityInputElement = subscriptionProductElement.querySelector('.product-quantity__input');
      productQuantityInputElement.value = 1;
    }
  });

  const totalQuantityElement = document.querySelector('[data-total-quantity]');
  if (totalQuantityElement) {
    totalQuantityElement.setAttribute('data-total-quantity', 0);
  }

  const subscribeFooterAtcElement = document.querySelector('.subscribe-footer-atc .contents span');
  if (subscribeFooterAtcElement) {
    subscribeFooterAtcElement.innerText = '0';
  }


}
if (document.querySelector('#subscription-collection')) {
  resetPage();
}
document.addEventListener('click', function (event) {
  if (event.target.matches('.cart-item-remove')) {
    document.querySelector('.loading-overlay').classList.add('visible');
    const t = event.target;
    const updates = {};
    const variantId = t.closest('.cart-popup-item').getAttribute('data-key');
    const removingQuantity = parseInt(t.closest('.cart-popup-item').querySelector('.item-quantity').innerText);
    const quantity = parseInt(document.querySelector('.cart-count-bubble span:first-child').innerText) - removingQuantity;

    updates[variantId] = 0;
    const data = { updates };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        cartUpdate();
        cartBubble(quantity);

        if (document.querySelector('#subscription-collection')) {
          const variantIDonly = variantId.split(':');
          const newQty = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').getAttribute('data-quantity')) - removingQuantity;
          document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').classList.remove('in-cart').setAttribute('data-quantity', newQty);

          const totalQuantity = parseInt(document.querySelector('[data-total-quantity]').getAttribute('data-total-quantity')) - removingQuantity;
          const line_total_original = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').querySelector('[data-compare-price]').getAttribute('data-compare-price')) * removingQuantity;
          const original = parseInt(document.querySelector('.subscribe-footer-totals .subtotal .money').getAttribute('data-amount')) - line_total_original;
          const line_total_price = parseInt(document.querySelector('.subscription_product[data-variant="' + variantIDonly[0] + '"]').querySelector('[data-price]').getAttribute('data-price')) * removingQuantity;
          const price = parseInt(document.querySelector('.subscribe-footer-totals .total .money').getAttribute('data-amount')) - line_total_price;
          const saving = original - price;
          subscribeFooter(totalQuantity, original, price, saving);
        }
      })
      .catch(error => console.error('Error:', error));
  }
});

document.addEventListener('click', function (e) {
  if (e.target.matches('.header__icon--cart')) {
    e.preventDefault();
    if (document.querySelector('.cart-popup')) {
      document.querySelector('.cart-popup').classList.toggle('visible')
    }
    document.body.classList.add('cart-open');
  }
});

window.addEventListener('resize', function () {
  cartPopupPos();
});

// Product Free Gift Logic
async function fetchCart() {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const responseData = await response.json();
  return responseData;
}

const FREE_HYDRATION_LINE_PROP = '_free_hydration';
/** Variant ID used when adding the signup gift via Klaviyo. */
const FREE_HYDRATION_PACK_VARIANT_ID = 43338623221849;

function lineItemIsFreeHydrationPromotion(item) {
  if (!item || !item.properties) return false;
  const v = item.properties[FREE_HYDRATION_LINE_PROP];
  if (v === undefined || v === null) return false;
  const s = String(v).toLowerCase();
  return s === 'true' || s === '1';
}

/** If promo lines exceed qty 1, clamp via cart/update.js (server truth). */
async function clampFreeHydrationLineQuantities(cart) {
  if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;
  const updates = {};
  for (const item of cart.items) {
    if (lineItemIsFreeHydrationPromotion(item) && Number(item.quantity) > 1) {
      updates[item.key] = 1;
    }
  }
  if (Object.keys(updates).length === 0) return false;
  try {
    const res = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    return res.ok;
  } catch {
    return false;
  }
}

function cartContainsOnlyFreeHydrationPromotionItems(cart) {
  if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;
  return cart.items.every(lineItemIsFreeHydrationPromotion);
}

function applyFreeHydrationCheckoutRestriction(cart) {
  const messageEl = document.getElementById('free-hydration-message');
  const checkoutBtn = document.getElementById('CartDrawer-Checkout');
  const onlyPromoFree = cartContainsOnlyFreeHydrationPromotionItems(cart);

  if (messageEl) {
    messageEl.style.display = onlyPromoFree ? 'block' : 'none';
  }
  if (checkoutBtn) {
    if (onlyPromoFree) {
      checkoutBtn.setAttribute('data-free-hydration-blocked', 'true');
    } else {
      checkoutBtn.removeAttribute('data-free-hydration-blocked');
    }
  }
  initCartDrawerFreeHydrationCheckoutGuard();
}

async function syncFreeHydrationCheckoutRestriction() {
  try {
    let cart = await fetchCart();
    if (await clampFreeHydrationLineQuantities(cart)) {
      await refreshCartDrawerSectionDom(false);
      cart = await fetchCart();
    }
    applyFreeHydrationCheckoutRestriction(cart);
  } catch (e) {
    console.error('syncFreeHydrationCheckoutRestriction:', e);
  }
}

window.syncFreeHydrationCheckoutRestriction = syncFreeHydrationCheckoutRestriction;

function initCartDrawerFreeHydrationCheckoutGuard() {
  const form = document.getElementById('CartDrawer-Form');
  if (!form || form.dataset.freeHydrationSubmitGuard === '1') return;
  form.dataset.freeHydrationSubmitGuard = '1';
  form.addEventListener(
    'submit',
    function (e) {
      const btn = document.getElementById('CartDrawer-Checkout');
      if (!btn || e.submitter !== btn) return;
      if (btn.getAttribute('data-free-hydration-blocked') === 'true') {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );
}

function initFreeHydrationCheckoutRestriction() {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // Defer: product-form publishes cart-update before cart-drawer renderContents, so DOM must update first.
      setTimeout(() => {
        syncFreeHydrationCheckoutRestriction();
      }, 0);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreeHydrationCheckoutRestriction);
  } else {
    syncFreeHydrationCheckoutRestriction();
  }
}

initFreeHydrationCheckoutRestriction();

function getCartDrawerElement() {
  return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
}

function getCartSectionNames() {
  const cart = getCartDrawerElement();
  if (cart && typeof cart.getSectionsToRender === 'function') {
    return cart.getSectionsToRender().map((section) => section.section || section.id);
  }
  return ['cart-drawer', 'cart-icon-bubble'];
}

function getCartSectionsRequestFields() {
  return {
    sections: getCartSectionNames(),
    sections_url: window.location.pathname
  };
}

function refreshCartDrawerFromApiResponse(parsedState) {
  const cartDrawer = document.querySelector('cart-drawer');
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  const renderer = cartDrawerItems || cartDrawer;
  if (!renderer || !parsedState || !parsedState.sections) return false;

  renderer.getSectionsToRender().forEach((section) => {
    const sectionHtml = parsedState.sections[section.section];
    if (!sectionHtml) return;
    const root = document.getElementById(section.id);
    if (!root) return;
    const target = section.selector ? (root.querySelector(section.selector) || root) : root;
    if (typeof renderer.getSectionInnerHTML === 'function') {
      target.innerHTML = renderer.getSectionInnerHTML(sectionHtml, section.selector);
    }
  });

  if (cartDrawer && parsedState.item_count !== undefined) {
    cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
    const inner = cartDrawer.querySelector('.drawer__inner');
    if (inner) inner.classList.toggle('is-empty', parsedState.item_count === 0);
  }
  syncFreeHydrationCheckoutRestriction();
  return true;
}

async function fetchProductSubscriptionInfo(productHandle, cartVariantId) {
  if (!productHandle) return null;
  try {
    const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
    if (!response.ok) return null;
    const product = await response.json();
    const variant = product.variants.find((v) => String(v.id) === String(cartVariantId)) || product.variants[0];
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return null;

    let sellingPlanId = null;
    if (product.selling_plan_groups && product.selling_plan_groups.length) {
      for (const group of product.selling_plan_groups) {
        for (const plan of group.selling_plans) {
          const planName = (plan.name || '').toLowerCase();
          if (planName.includes('duplicate') || planName.includes('90') || planName.includes('quarter') || planName.includes('3 month')) continue;
          if (planName.includes('30') || (plan.options && plan.options.some((o) => String(o.value || '').includes('30')))) {
            sellingPlanId = plan.id;
            break;
          }
        }
        if (sellingPlanId) break;
      }
    }
    if (!sellingPlanId) {
      sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;
    }
    return { variantId: variant.id, sellingPlanId: sellingPlanId };
  } catch (error) {
    console.error('fetchProductSubscriptionInfo:', error);
    return null;
  }
}

function cartHasSubscriptionForVariant(cartData, variantId, sellingPlanId) {
  if (!cartData || !cartData.items) return false;
  return cartData.items.some((item) => {
    if (String(item.id) !== String(variantId)) return false;
    if (!item.selling_plan_allocation) return false;
    if (sellingPlanId && item.selling_plan_allocation.selling_plan) {
      return String(item.selling_plan_allocation.selling_plan.id) === String(sellingPlanId);
    }
    return true;
  });
}

function isQuarterlySellingPlan({ planLabel, sellingPlanName, buttonFrequency, buttonUnitType }) {
  const label = (planLabel || '').toLowerCase().trim();
  const name = (sellingPlanName || '').toLowerCase().trim();
  const combined = `${label} ${name}`.trim();
  const unitType = (buttonUnitType || '').toLowerCase().trim();

  if (buttonFrequency === '90' || (unitType.includes('day') && buttonFrequency === '90')) return true;
  if (unitType.includes('month') && buttonFrequency === '3') return true;
  if (name.includes('3 bundles every 90 days') || combined.includes('3 bundles every 90 days')) return true;
  if ((name.includes('3 bundle') || combined.includes('3 bundle')) && (name.includes('90') || combined.includes('90'))) return true;
  if (name.includes('every 90 days') || combined.includes('every 90 days')) return true;
  if (label === 'ships every 90 days') return true;
  if (label.includes('every 3 months') || label.includes('3 months') || name.includes('every 3 months')) return true;
  if (label.includes('quarterly') || name.includes('quarterly')) return true;
  if ((label.includes('90') || name.includes('90')) && !label.includes('30') && !name.includes('30 day')) return true;

  return false;
}

function isMonthlySellingPlan({ planLabel, sellingPlanName, buttonFrequency, isQuarterly }) {
  if (isQuarterly) return false;

  const label = (planLabel || '').toLowerCase().trim();
  const name = (sellingPlanName || '').toLowerCase().trim();

  if (buttonFrequency === '30') return true;
  if (label === 'every month' || label.includes('every month')) return true;
  if (label.includes('monthly') || name.includes('monthly')) return true;
  if ((label.includes('30') || name.includes('30 day')) && !name.includes('90')) return true;

  return false;
}

async function handleSubscribeAddToCart({ currentTarget }) {
  // Add loading class
  currentTarget.classList.add("custom-loading");

  // Fetch latest snapshot of cart
  const cartJson = await fetchCart();

  const itemsArray = [];
  // Get data from attributes
  const variantId = currentTarget.getAttribute("data-variant");
  const freeGiftVariantId = currentTarget.getAttribute("data-free-gift-id");
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);

  // Cart drawer promotional product: add only the promo variant, no selling plan, no additional variants
  const isPromotionalProduct = currentTarget.classList.contains('promotional_product') || currentTarget.closest('.cart_promotion_banner');
  if (isPromotionalProduct && variantId) {
    const promoItem = { id: variantId, quantity: 1, properties: {} };
    const headers = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [promoItem] }) };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
    const data = await response.json();
    currentTarget.classList.remove("custom-loading");
    if (data.status) {
      console.error('Cart add error (promotional):', data);
      alert(data.description || 'Error adding promotional item to cart');
      return;
    }
    defaultCartDrawerUpdate();
    return;
  }

  // Determine container for scoping (PDP vs Collection Grid)
  const productContainer = currentTarget.closest('.card_product_subscription') || currentTarget.closest('.card-wrapper') || currentTarget.closest('.product') || document;

  // Prefer the plan radio in the same collapsible section as the clicked button
  const clickedPlanContainer = currentTarget.closest('.collapsible-button');
  const checkedPlanRadio = (clickedPlanContainer && clickedPlanContainer.querySelector('input[type="radio"]'))
    || productContainer.querySelector('input.select-plan:checked')
    || productContainer.querySelector('.collapsible_subscription_main.active input[type="radio"]')
    || productContainer.querySelector('input[type="radio"][name*="collapsible--btn"]:checked');
  const planLabel = checkedPlanRadio ? checkedPlanRadio.getAttribute('data-label') : '';
  const sellingPlanName = currentTarget.getAttribute('data-selling-plan-name')
    || (checkedPlanRadio && checkedPlanRadio.getAttribute('data-selling-plan-name'))
    || (clickedPlanContainer && clickedPlanContainer.getAttribute('data-selling'))
    || planLabel
    || '';
  console.log('Plan label:', planLabel, 'Selling plan name:', sellingPlanName);

  const buttonFrequency = currentTarget.getAttribute('data-frequency');
  const buttonUnitType = currentTarget.getAttribute('data-unit_type');
  const is90Days = isQuarterlySellingPlan({ planLabel, sellingPlanName, buttonFrequency, buttonUnitType });
  const is30Days = isMonthlySellingPlan({ planLabel, sellingPlanName, buttonFrequency, isQuarterly: is90Days });

  console.log('Plan selection:', { planLabel, sellingPlanName, is30Days, is90Days, buttonFrequency });

  function resolveSellingPlanId(buttonEl) {
    if (!buttonEl) return null;
    if (is30Days) return buttonEl.getAttribute('data-sellingplanid');
    if (is90Days) return buttonEl.getAttribute('data-quater-id') || buttonEl.getAttribute('data-sellingplanid');
    return buttonEl.getAttribute('data-sellingplanid') || buttonEl.getAttribute('data-quater-id');
  }

  let sellingPlanId = null;
  const planContainer = clickedPlanContainer || (checkedPlanRadio && checkedPlanRadio.closest('.collapsible-button'));
  if (planContainer) {
    sellingPlanId = resolveSellingPlanId(planContainer.querySelector('.subscribe-button'));
  }
  if (!sellingPlanId) {
    sellingPlanId = resolveSellingPlanId(currentTarget);
  }

  console.log('Main product selling plan ID:', sellingPlanId);

  // Every 3 months (quarterly): main product quantity = 3. Every month or one-time: use custom-quantity or 1
  let quantity = 1;
  const productTags = currentTarget.getAttribute('data-tag') || '';
  const isLiposomal = productTags.includes('Liposomal');

  if (is90Days) {
    quantity = 3;
  } else if (is30Days && isLiposomal) {
    quantity = 2;
  } else if (currentTarget.hasAttribute('custom-quantity')) {
    quantity = parseInt(currentTarget.getAttribute('custom-quantity'), 10) || 1;
  }
  const uniqueId = new Date().getTime();

  // Scope variant boxes to the product container
  const variantBoxesCheck = productContainer.querySelectorAll('.variants-box');
  const hasAdditionalVariantsWithQty = Array.from(variantBoxesCheck).some(box => {
    const qtyInput = box.querySelector('.qty-numbers');
    return qtyInput && (parseInt(qtyInput.value, 10) || 0) > 0;
  });

  const itemsToAdd = [];
  const itemsToUpdate = [];
  let mainProductItem = null;
  let mainProductNeedsUpdate = false;

  if (!hasAdditionalVariantsWithQty) {
    // Check if main product with same variant and selling plan already exists in cart
    const existingMainCartItem = cartJson.items.find(item => {
      if (String(item.variant_id) !== String(variantId)) return false;
      const itemSellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
      if (sellingPlanId) {
        if (!itemSellingPlanId || String(itemSellingPlanId) !== String(sellingPlanId)) return false;
      } else {
        if (itemSellingPlanId) return false;
      }
      return true;
    });

    if (existingMainCartItem) {
      const newQuantity = existingMainCartItem.quantity + quantity;
      itemsToUpdate.push({ id: existingMainCartItem.key, quantity: newQuantity });
      mainProductNeedsUpdate = true;
      mainProductItem = { id: variantId, selling_plan: sellingPlanId, quantity: quantity, properties: {} };
    } else {
      mainProductItem = { id: variantId, selling_plan: sellingPlanId, quantity: quantity, properties: {} };
      itemsArray.push(mainProductItem);
    }

    if (freeGiftVariantId && !cartHasGiftProduct) {
      const freeGiftItem = { id: freeGiftVariantId, quantity: 1, properties: { _custom_free_gift_id: uniqueId } };
      if (mainProductItem) mainProductItem.properties["_custom_free_gift"] = uniqueId;
      itemsArray.push(freeGiftItem);
    }
  }

  let hasAdditionalVariants = false;
  const variantBoxes = productContainer.querySelectorAll('.variants-box');

  variantBoxes.forEach(box => {
    const qtyInput = box.querySelector('.qty-numbers');
    if (!qtyInput) return;

    const inputQty = parseInt(qtyInput.value, 10) || 0;
    if (inputQty <= 0) return;
    // Every 3 months (quarterly): each additional variant sends quantity 3. Every month or one-time: use input value
    let qty = is90Days ? 3 : inputQty;
    if (is30Days && isLiposomal) {
      qty = 2;
    }

    const extraVariantId = box.getAttribute('data-variant-id');
    if (!extraVariantId) return;

    if (extraVariantId == variantId) return;

    let extraSellingPlanId = null;
    if (is30Days) {
      extraSellingPlanId = box.getAttribute('data-sellingplanid');
    } else if (is90Days) {
      extraSellingPlanId = box.getAttribute('data-quater-id') || box.getAttribute('data-sellingplanid');
    } else {
      extraSellingPlanId = box.getAttribute('data-sellingplanid') || box.getAttribute('data-quater-id');
    }

    // Check if this variant with the same selling plan already exists in cart
    const existingCartItem = cartJson.items.find(item => {
      // Match by variant ID
      if (String(item.variant_id) !== String(extraVariantId)) return false;

      // Match by selling plan ID
      const itemSellingPlanId = item.selling_plan_allocation?.selling_plan?.id;
      if (extraSellingPlanId) {
        // If we have a selling plan, the cart item must have the same one
        if (!itemSellingPlanId || String(itemSellingPlanId) !== String(extraSellingPlanId)) {
          return false;
        }
      } else {
        // If we don't have a selling plan, the cart item shouldn't have one either
        if (itemSellingPlanId) return false;
      }

      return true;
    });

    if (existingCartItem) {
      // Item exists with same variant and plan - update quantity
      const newQuantity = existingCartItem.quantity + qty;
      itemsToUpdate.push({
        id: existingCartItem.key,
        quantity: newQuantity
      });
    } else {
      // New item - add to cart
      const extraItem = { id: extraVariantId, quantity: qty, properties: {} };
      if (extraSellingPlanId) extraItem.selling_plan = extraSellingPlanId;
      // Add property to identify this as an additional variant for display in cart
      extraItem.properties["Additional Variant"] = "True";
      itemsToAdd.push(extraItem);
    }

    hasAdditionalVariants = true;
  });

  // Add new items to itemsArray
  itemsArray.push(...itemsToAdd);

  // When we have additional variants, link main + additional items with same timestamp so removing main removes all
  // Note: If main product is being updated, we can't add properties to it via update API, so grouping only applies to new items
  if (hasAdditionalVariants && !mainProductNeedsUpdate) {
    const groupId = String(uniqueId);
    if (mainProductItem) {
      mainProductItem.properties["_subscription_group_id"] = groupId;
    }
    itemsArray.forEach(function (item) {
      if (item !== mainProductItem && String(item.id) !== String(freeGiftVariantId)) {
        if (!item.properties) item.properties = {};
        item.properties["_subscription_group_id"] = groupId;
      }
    });
  }

  // Debug: log what we're trying to add/update
  console.log('Adding items to cart:', itemsArray);
  console.log('Updating existing items:', itemsToUpdate);

  // First, update existing items if any
  if (itemsToUpdate.length > 0) {
    const updates = {};
    itemsToUpdate.forEach(item => {
      updates[item.id] = item.quantity;
    });

    const updateHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) };
    const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, updateHeaders);
    const updateData = await updateResponse.json();

    // Check for errors
    if (updateData.status) {
      console.error('Cart update error:', updateData);
      alert(updateData.description || 'Error updating cart items');
      currentTarget.classList.remove("custom-loading");
      return;
    }
  }

  // Then, add new items if any
  if (itemsArray.length > 0) {
    const headers = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsArray }) };
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, headers);
    const data = await response.json();

    // Check for errors
    if (data.status) {
      console.error('Cart add error:', data);
      alert(data.description || 'Error adding items to cart');
      currentTarget.classList.remove("custom-loading");
      return;
    }
  }

  currentTarget.classList.remove("custom-loading");
  const closestSubscription = currentTarget.closest('.card_product_subscription');
  console.log('Items added/updated to cart [Subscription]');
  // resetExpandWidget();
  defaultCartDrawerUpdate().then(function () {
    setTimeout(function () {
      if (typeof window.resetAdditionalProductQuantitiesAfterAddToCart === 'function') {
        window.resetAdditionalProductQuantitiesAfterAddToCart();
      }
    }, 500);
  });
  // Keep sacing/total_month_saving showing actual calculated total (main + variants)
  if (typeof window.updateSubscriptionPrices === 'function') {
    window.updateSubscriptionPrices();
  }
}

if (!window.__subscribeButtonListenerAttached) {
  window.__subscribeButtonListenerAttached = true;
  document.addEventListener('click', function (event) {
    const subscribeButton = event.target.closest('.subscribe-button:not(.subscribe-button-soldout)');
    if (!subscribeButton) return;
    event.preventDefault();
    handleSubscribeAddToCart({ currentTarget: subscribeButton });
  }, true);
}

// Cart Subscriptions Logic - change monthly plan to quarterly (same line item, update selling_plan via cart/change.js)
async function upgradeToQuarterlySubscription(event) {
  const currentTarget = event && (event.currentTarget || event.target);
  const subscriptionCover = currentTarget && currentTarget.closest(".subscription__cover");
  if (!subscriptionCover) return;

  const oldLineItemEl = subscriptionCover.querySelector('.old_lineItem_id');
  const lineItemKey = oldLineItemEl ? oldLineItemEl.getAttribute('data-old-lineitem-id') : null;
  const quantityEl = subscriptionCover.querySelector('.lineItem_quantity');
  const lineItemIdEl = subscriptionCover.querySelector('.lineItem_id');
  const variantIdForAdd = lineItemIdEl ? lineItemIdEl.getAttribute('data-lineitem-id') : null;
  const quantity = quantityEl ? quantityEl.getAttribute('data-lineitem-quantity') : '1';
  const sellingIdEl = subscriptionCover.querySelector('.selling_id');
  const newSellingPlanId = sellingIdEl ? sellingIdEl.getAttribute('data-selling-id') : null;

  if (!lineItemKey || !newSellingPlanId) {
    console.error('upgradeToQuarterlySubscription: missing lineItemKey or selling plan id');
    return;
  }

  const cartJson = await fetchCart();
  const itemIndex = cartJson.items.findIndex(function (item) { return String(item.key) === String(lineItemKey); });
  if (itemIndex === -1) {
    console.error('upgradeToQuarterlySubscription: line item not found in cart');
    return;
  }
  const cartItem = cartJson.items[itemIndex];
  const properties = (cartItem && cartItem.properties) ? cartItem.properties : {};
  const line = itemIndex + 1;
  const quarterlyQuantity = 3;

  const updates = {
    line: line,
    quantity: quarterlyQuantity,
    selling_plan: Number(newSellingPlanId),
    properties: properties,
    ...getCartSectionsRequestFields()
  };

  const changeHeaders = { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) };
  const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, changeHeaders);
  const data = await response.json();

  if (data && data.status && data.status !== 200) {
    // Fallback for main product: cart/change can fail with "Cannot apply selling plan to variant". Remove line and re-add with correct variant + selling plan.
    const useFallback = (data.status === 422 && data.description && data.description.indexOf('selling plan') !== -1) || data.status !== 200;
    if (useFallback) {
      const variantId = (variantIdForAdd && variantIdForAdd.trim() !== '') ? Number(variantIdForAdd) : cartItem.id;
      const removePayload = { id: lineItemKey, quantity: 0, ...getCartSectionsRequestFields() };
      const removeRes = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(removePayload)
      });
      const removeData = await removeRes.json();
      if (removeData && removeData.status && removeData.status !== 200) {
        console.error('Cart remove error:', removeData);
        if (removeData.description) alert(removeData.description);
        return;
      }
      const addPayload = {
        items: [{
          id: variantId,
          quantity: quarterlyQuantity,
          selling_plan: Number(newSellingPlanId),
          properties: properties
        }],
        ...getCartSectionsRequestFields()
      };
      const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(addPayload)
      });
      const addData = await addRes.json();
      if (addData && addData.status && addData.status !== 200) {
        console.error('Cart add error:', addData);
        if (addData.description) alert(addData.description);
        return;
      }
      if (!refreshCartDrawerFromApiResponse(addData)) defaultCartDrawerUpdate(false);
      return;
    }
    console.error('Cart change error:', data);
    if (data.description) alert(data.description);
    return;
  }

  if (!refreshCartDrawerFromApiResponse(data)) defaultCartDrawerUpdate(false);
}

async function upgradeToSubscription(event) {
  const currentTarget = event && (event.currentTarget || event.target);
  const subscriptionCover = currentTarget && currentTarget.closest(".subscription__cover");
  if (!subscriptionCover || !currentTarget) return;

  currentTarget.disabled = true;
  const jsonHeaders = { 'Content-Type': 'application/json' };

  let cartJson = await fetchCart();
  const freeGiftVariantId = currentTarget.getAttribute('data-free-gift-id');
  const cartHasGiftProduct = cartJson.items.find((item) => item.id == freeGiftVariantId);
  const uniqueId = new Date().getTime();

  if (!cartHasGiftProduct && freeGiftVariantId) {
    await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: jsonHeaders,
      body: JSON.stringify({
        items: [{ id: Number(freeGiftVariantId), quantity: 1, properties: { _custom_free_gift_id: uniqueId } }]
      })
    });
    cartJson = await fetchCart();
  }

  const quantityEl = subscriptionCover.querySelector('.lineItem_quantity');
  const oldLineItemEl = subscriptionCover.querySelector('.old_lineItem_id');
  const lineItemIdEl = subscriptionCover.querySelector('.lineItem_id');

  const lineItemKey = currentTarget.getAttribute('data-line-item-key')
    || (oldLineItemEl && oldLineItemEl.getAttribute('data-old-lineitem-id'));
  const productHandle = currentTarget.getAttribute('data-product-handle');
  let sellingPlanId = currentTarget.getAttribute('data-selling-plan-id');
  const variantIdFromDom = (currentTarget.getAttribute('data-variant-id')
    || (lineItemIdEl && lineItemIdEl.getAttribute('data-lineitem-id')) || '').trim();

  if (!lineItemKey) {
    console.error('upgradeToSubscription: missing line item key');
    currentTarget.disabled = false;
    return;
  }

  const quantity = quantityEl ? quantityEl.getAttribute('data-lineitem-quantity') : '1';
  const liposomalUpgradeQty = parseInt(currentTarget.getAttribute('data-liposomal-upgrade-qty') || '', 10);
  const cartRowText = (subscriptionCover.closest('tr') && subscriptionCover.closest('tr').innerText) ? subscriptionCover.closest('tr').innerText.toLowerCase() : '';
  const inferredLiposomalQty = cartRowText.indexOf('liposomal') !== -1 ? 2 : NaN;
  const enforcedLiposomalQty = Number.isFinite(liposomalUpgradeQty) ? liposomalUpgradeQty : inferredLiposomalQty;
  const parsedQuantity = parseInt(quantity, 10);
  const effectiveQuantity = Number.isFinite(enforcedLiposomalQty)
    ? Math.max(Number.isFinite(parsedQuantity) ? parsedQuantity : 1, enforcedLiposomalQty)
    : (Number.isFinite(parsedQuantity) ? parsedQuantity : 1);

  const cartItem = cartJson.items.find(function (item) { return String(item.key) === String(lineItemKey); });
  if (!cartItem) {
    console.error('upgradeToSubscription: line item not found in cart');
    currentTarget.disabled = false;
    return;
  }

  let subscriptionVariantId = variantIdFromDom ? Number(variantIdFromDom) : null;
  if (!sellingPlanId || !subscriptionVariantId || Number.isNaN(subscriptionVariantId)) {
    const productInfo = await fetchProductSubscriptionInfo(productHandle || cartItem.handle, cartItem.id);
    if (productInfo) {
      sellingPlanId = sellingPlanId || String(productInfo.sellingPlanId);
      subscriptionVariantId = subscriptionVariantId || productInfo.variantId;
    }
  }

  if (!sellingPlanId || !subscriptionVariantId || Number.isNaN(subscriptionVariantId)) {
    console.error('upgradeToSubscription: missing subscription variant or selling plan');
    alert('Unable to upgrade this item. Please remove it and add a subscription from the product page.');
    currentTarget.disabled = false;
    return;
  }

  const existingProperties = (cartItem.properties) ? Object.assign({}, cartItem.properties) : {};
  const properties = Object.assign({}, existingProperties);
  if (freeGiftVariantId) {
    properties._custom_free_gift = uniqueId;
  }

  function finishCartUpgrade(apiResponse) {
    currentTarget.disabled = false;
    if (apiResponse && refreshCartDrawerFromApiResponse(apiResponse)) return;
    defaultCartDrawerUpdate(false);
  }

  async function applySellingPlanToLine() {
    const changeRes = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: jsonHeaders,
      body: JSON.stringify({
        id: lineItemKey,
        quantity: effectiveQuantity,
        selling_plan: Number(sellingPlanId),
        properties: properties,
        ...getCartSectionsRequestFields()
      })
    });
    const changeData = await changeRes.json();
    return { changeRes, changeData };
  }

  async function removeLineItem() {
    const removeRes = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: jsonHeaders,
      body: JSON.stringify({
        id: lineItemKey,
        quantity: 0,
        ...getCartSectionsRequestFields()
      })
    });
    const removeData = await removeRes.json();
    if (!removeRes.ok || (removeData.status && removeData.status !== 200)) {
      console.error('Cart remove error:', removeData);
      if (removeData.description) alert(removeData.description);
      return null;
    }
    return removeData;
  }

  async function addSubscriptionLine() {
    const addRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: jsonHeaders,
      body: JSON.stringify({
        items: [{
          id: subscriptionVariantId,
          quantity: effectiveQuantity,
          selling_plan: Number(sellingPlanId),
          properties: properties
        }],
        ...getCartSectionsRequestFields()
      })
    });
    const addData = await addRes.json();
    if (!addRes.ok || (addData.status && addData.status !== 200)) {
      console.error('Cart add error:', addData);
      if (addData.description) alert(addData.description);
      return null;
    }
    return addData;
  }

  // Same variant (Recharge native single-SKU): attach selling plan to existing line via cart/change.js
  if (String(subscriptionVariantId) === String(cartItem.id)) {
    const { changeRes, changeData } = await applySellingPlanToLine();
    if (changeRes.ok && (!changeData.status || changeData.status === 200) && cartHasSubscriptionForVariant(changeData, cartItem.id, sellingPlanId)) {
      finishCartUpgrade(changeData);
      return;
    }
  }

  const removeData = await removeLineItem();
  if (!removeData) {
    currentTarget.disabled = false;
    return;
  }
  const addData = await addSubscriptionLine();
  if (!addData) {
    currentTarget.disabled = false;
    return;
  }

  finishCartUpgrade(addData.sections ? addData : removeData);
}

window.upgradeToSubscription = upgradeToSubscription;
window.upgradeToQuarterlySubscription = upgradeToQuarterlySubscription;

document.addEventListener('submit', function (event) {
  const form = event.target.closest('product-grid-form form');
  if (!form) return;

  event.preventDefault();
  const submitButton = form.querySelector('[type="submit"]');
  if (submitButton) {
    submitButton.classList.add('custom-loading');
  }
  const variantID = form.querySelector('[name="id"]').value;
  const productArray = [
    {
      variantID,
      variantQuantity: 1
    }
  ];
  addAllItems(productArray);
});

function syncOneTimePaymentMessaging(widgetDiv) {
  if (!widgetDiv) return;
  const card = widgetDiv.closest('.card_product_subscription');
  if (!card || !card.querySelector('.product-payments-messaging--one-time-only')) return;
  const active = widgetDiv.querySelector('.collapsible_subscription_main.active');
  const isOneTime = !!(active && active.classList.contains('collapsible-button__onetime'));
  card.classList.toggle('is-one-time-plan', isOneTime);
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll('.hydration-pdp .widget_button, .new-bundle-product .widget_button')
    .forEach(syncOneTimePaymentMessaging);

  document.addEventListener('click', function (el) {
    const button = el.target.closest('.widget_button .collapsible-button');
    if (!button) return;

    const widget_div = button.closest('.widget_button');
    if (!widget_div) return;

    const Collapsible_Buttons = widget_div.querySelectorAll('.collapsible-button');
    const inputCheck = button.querySelector('.title-label input');

    Collapsible_Buttons.forEach(function (btn) {
      btn.classList.remove('active');
    });
    if (!button.classList.contains('active')) {
      button.classList.add('active');
    }
    if (inputCheck) {
      inputCheck.checked = true;
    }

    var Saving_value = '';
    var total_value = '';
    var saving_text = '';
    const Activated_button = widget_div.querySelector('.collapsible_subscription_main.active');
    const subscription_text_footer = widget_div.querySelector('.subscription__text_footer');
    const subscription_text_html = Activated_button?.querySelector('.subscription__text')?.innerHTML;
    if (Activated_button) {
      Saving_value = Activated_button.getAttribute('data-saving-value');
      total_value = Activated_button.getAttribute('data-total-value');
      saving_text = Activated_button.getAttribute('data-saving-text');
    }
    const collapsible_button_total_wrp = widget_div.querySelector('.collapsible_button_total_wrp');
    if (collapsible_button_total_wrp) {
      const moneyFormat = document.body.getAttribute('data-format') || Shopify.money_format;
      const formatMoneyValue = function (val, allowNegative) {
        if (val == null || val === '') return val;
        var str = String(val).trim();
        var isNegative = allowNegative && str.indexOf('-') === 0;
        if (isNegative) str = str.replace(/^-/, '').trim();
        if (!allowNegative) {
          if (str.indexOf('-') === 0) str = str.replace(/^-/, '').trim();
          str = str.replace(/([£€$])-\s*/g, '$1');
        }
        if (/[£€$]/.test(str)) return (isNegative ? '-' : '') + str;
        var num = parseFloat(str.replace(/[^\d.]/g, '')) || 0;
        var cents = Math.round(num * 100);
        var formatted = typeof Shopify.formatMoney === 'function' ? Shopify.formatMoney(cents, moneyFormat) : str;
        return (isNegative ? '-' : '') + formatted;
      };
      const savingEle = collapsible_button_total_wrp.querySelector('.sacing');
      if (savingEle) {
        savingEle.querySelectorAll('span')[1].innerText = formatMoneyValue(Saving_value, false);
      }
      const totalEle = collapsible_button_total_wrp.querySelector('.sacing.total_month_saving');
      if (totalEle) {
        totalEle.querySelectorAll('span')[1].innerText = formatMoneyValue(total_value, false);
        totalEle.querySelectorAll('span')[0].innerText = saving_text;
      }
    }
    // Recalculate total (main + variants) so sacing/total_month_saving show actual total when variant qtys > 0
    if (typeof window.updateSubscriptionPrices === 'function') {
      window.updateSubscriptionPrices();
    }
    if (subscription_text_footer && subscription_text_html) {
      subscription_text_footer.innerHTML = subscription_text_html;
    } else {
      if (subscription_text_footer) subscription_text_footer.innerHTML = '';
    }

    syncOneTimePaymentMessaging(widget_div);
  });

  function normalizeSavingDisplay() {
    document.querySelectorAll('.collapsible_button_total_wrp').forEach(function (wrp) {
      const savingEle = wrp.querySelector('.sacing:not(.total_month_saving)');
      if (!savingEle) return;
      const span = savingEle.querySelectorAll('span')[1];
      if (!span || !span.textContent) return;
      var t = span.textContent.trim();
      if (/[£€$]-\s*[\d.,]/.test(t)) span.textContent = t.replace(/([£€$])-\s*/g, '$1');
    });
  }
  normalizeSavingDisplay();

});

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.collapsible-add-button');
    if (button) {
      triggerRelatedButton(event);
    }
  });
});

function resetExpandWidget() {
  const All_card_product_subscriptions = document.querySelectorAll('.card_product_subscription');
  if (All_card_product_subscriptions.length > 0) {
    All_card_product_subscriptions.forEach(card_product_subscription => {
      if (card_product_subscription) {
        const nearestLi = card_product_subscription?.closest('li');
        const widget_button = card_product_subscription?.querySelector('.widget_button');
        const collapsible_expand_button = card_product_subscription?.querySelector('.collapsible-expand-button')?.querySelector('button');
        if (collapsible_expand_button && collapsible_expand_button.hasAttribute('hidden')) collapsible_expand_button.removeAttribute('hidden');
        if (widget_button && widget_button.classList.contains('widget-expanded')) widget_button.classList.remove('widget-expanded');
        if (nearestLi && nearestLi.classList.contains('js-widget-expanded')) nearestLi.classList.remove('js-widget-expanded');
      }
    })
  }
}

function expand_widget(event) {
  const _this = event.target;
  const nearestLi = _this?.closest('li');
  const nearestEle = _this?.closest('.card_product_subscription');
  if (nearestEle && nearestLi) {
    const widgetEle = nearestEle?.querySelector('.widget_button');
    if (nearestLi) nearestLi.classList.add('js-widget-expanded');
    if (widgetEle) widgetEle.classList.add('widget-expanded');
    _this.setAttribute('hidden', true);
  }
}

function triggerRelatedButton(event) {
  const _this = event.target.closest('.collapsible-add-button') || event.target;
  const innerButton = _this.querySelector('button');
  if (!innerButton) return;
  innerButton.classList.add('custom-loading');
  const closestMainEle = _this?.closest('.card_product_subscription');
  const activatedOption = closestMainEle?.querySelector('.collapsible-button.collapsible_subscription_main.active');
  if (activatedOption?.classList.contains('collapsible-button__subscription')) {
    const subsLink = activatedOption?.querySelector('.subscription-link')?.querySelector('a');
    if (subsLink) subsLink.click();
    const monthlyButton = activatedOption?.querySelector('.subscription-link')?.querySelector('button');
    if (monthlyButton) monthlyButton.click();
    setTimeout(() => { innerButton.classList.remove('custom-loading') }, 1000);
  } else {
    const oneTimeAddButton = activatedOption?.querySelector('.one-time-add-button');
    if (oneTimeAddButton) {
      const ATCbutton = oneTimeAddButton.querySelector('button[name="add"]');
      if (ATCbutton) ATCbutton.click();
      setTimeout(() => { innerButton.classList.remove('custom-loading') }, 1000);
    }
  }
}


let tabs = document.querySelectorAll('.tab');
let tabContents = document.querySelectorAll('.tabContent');
if (document.getElementById('tabs')) {
  document.getElementById('tabs').addEventListener('click', function (event) {
    let target = event.target;

    if (target.classList.contains('tab')) {
      tabs.forEach((tab, index) => {
        if (tab === target) {
          hideTabsContent(0);
          tab.classList.add('whiteborder');
          tabContents[index].classList.remove('hide');
          tabContents[index].classList.add('show');
        }
      });
    }
  });
}

function hideTabsContent(startIndex) {
  for (let i = startIndex; i < tabContents.length; i++) {
    tabContents[i].classList.remove('show');
    tabContents[i].classList.add('hide');
    tabs[i].classList.remove('whiteborder');
  }
}

function toggleAccordion(sectionId, button) {
  var content = document.getElementById(sectionId);

  if (content.style.height === '0px' || content.style.height === '') {
    content.style.height = content.scrollHeight + 'px';
    button.classList.add("activeButton");
  } else {
    content.style.height = '0px';
    button.classList.remove("activeButton");
  }
}

document.querySelector(".loginopen-popup").addEventListener("click", function () {
  var loginElement = document.getElementById("loginpopup");
  document.querySelector("html").classList.add('overflow-hidden');
  loginElement.classList.toggle("show");
});

document.querySelector(".closepopup").addEventListener("click", function () {
  var loginElement = document.getElementById("loginpopup");
  document.querySelector("html").classList.remove('overflow-hidden');
  loginElement.classList.remove("show");
});


// Brandbassador/Club functionality 
function openClubPopup() {
  const allTheManualButtons = document.querySelectorAll('.js-brand_bassadorion-custom-button');
  if (allTheManualButtons.length > 0) {
    const club_widget_ele = document.querySelector('.js-club-widget-ele')?.querySelector('button');
    allTheManualButtons.forEach(button => {
      if (club_widget_ele) {
        clearTimeout(setTimeoutOnele);
        button.addEventListener('click', () => {
          club_widget_ele.click();
        })
      }
    })
  }
}

const setTimeoutOnele = setTimeout(openClubPopup, 300);

if (document.getElementById("countdown")) {
  if (document.querySelector('.countdown_main').getAttribute('date-reset') == "everyday") {
    // Update the countdown every 1 second
    var countdownInterval = setInterval(function () {
      // Get the current date and time
      var now = new Date().getTime();

      // Calculate the end time for the day (midnight of the next day)
      var endOfDay = new Date();
      endOfDay.setHours(24, 0, 0, 0); // Set the time to midnight of the next day
      var endOfDayTime = endOfDay.getTime();

      // Calculate the distance between now and the end time
      var distance = endOfDayTime - now;

      // Calculate hours, minutes, and seconds from the distance
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the countdown timer
      var timerElement = document.getElementById("countdown");
      timerElement.innerHTML = "<div><div>" + hours + "</div><span>hour(s)</span></div><div><div>" + minutes + "</div><span>minute(s)</span></div><div><div>" + seconds + "</div><span>second(s)</span></div>";

      // If the countdown is over (at the end of the day)
      if (distance <= 0) {
        // Clear the countdown interval
        clearInterval(countdownInterval);

        // Restart the countdown interval to count down to the next day's end time
        countdownInterval = setInterval(arguments.callee, 1000);
      }
    }, 0);
  } else {
    if (document.querySelector('.countdown_main').getAttribute('date-reset') == "specific_day") {
      // Set the date we're counting down to
      var TimerDate = document.getElementById("countdown").getAttribute("data-timer");
      console.log(TimerDate)
      var countDownDate = new Date(TimerDate).getTime();

      // Update the count down every 1 second
      var x = setInterval(function () {

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Output the result in an element with id="countdown"
        if (days > 0) {
          document.getElementById("countdown").innerHTML = "<div> <div>" + days + "</div><span>day(s)</span></div><div> <div>" + hours + "</div><span>hour(s)</span></div> <div> <div>" + minutes + "</div><span>minute(s)</span></div><div> <div>" + seconds + "</div><span>seconds(s)</span></div>";
        } else {
          document.getElementById("countdown").innerHTML = "<div> <div>" + hours + "</div><span>hour(s)</span></div> <div> <div>" + minutes + "</div><span>minute(s)</span></div><div> <div>" + seconds + "</div><span>seconds(s)</span></div>";
        }

        // If the count down is over, write some text 
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("countdown").innerHTML = "EXPIRED";
          setTimeout(() => { document.querySelector('.countdown_sticky').style.display = "none"; }, 500);
          document.body.style.setProperty('--counter-height', '0');
        } else {
          document.querySelector(".countdown_sticky").classList.remove("hidden");
        }
      }, 0);
    }
  }
}

// slick slider
if ($('.cs-slider-init').length) {
  $('.cs-slider-init').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    centerPadding: '10px',
    dots: true
  });
}

// new-bundle-product-template image slider
if (typeof Swiper !== 'undefined') {
  document.querySelectorAll('.bundle-product-media-list-desktop').forEach(function (el) {
    if (el.swiper) return;
    new Swiper(el, {
      slidesPerView: 1,
      centeredSlides: true,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true
      },
      fadeEffect: {
        crossFade: true
      }
    });
  });

  document.querySelectorAll('.bundle-product-media-list-mobile').forEach(function (el) {
    if (el.swiper) return;
    new Swiper(el, {
      slidesPerView: 1,
      centeredSlides: true,
      pagination: {
        el: el.querySelector('.swiper-pagination-mobile'),
        clickable: true,
        dynamicBullets: true
      },
      fadeEffect: {
        crossFade: true
      }
    });
  });
}

// hydration-product-template image slider
var mySwiper = new Swiper('.hydration-product.bundle-product-media-list-desktop', {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },

  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true
  },

  fadeEffect: {
    crossFade: true
  }
});

var mySwiper_mobile = new Swiper('.hydration-product.bundle-product-media-list-mobile', {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,

  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },

  pagination: {
    el: '.swiper-pagination-mobile',
    clickable: true,
    dynamicBullets: true
  },

  fadeEffect: {
    crossFade: true
  }
});

const mainSlider = new Swiper(".mySwiper-main", {
  pagination: {
    el: ".swiper-pagination-main",
    clickable: true,
  },
});



const swiperMeta = new Swiper(".mySwiper-meta", {
  autoplay: {
    delay: 3000, // 3 seconds
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination-meta",
  },
});



// Event delegation so ingredients more/less works in Quick Shop modals too
if (!window.__productDetailsMoreLessDelegated) {
  window.__productDetailsMoreLessDelegated = true;
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.more, .less');
    if (!button) return;

    const parentCard = button.closest('.product-body-details-column');
    if (!parentCard) return;

    event.preventDefault();
    parentCard.classList.toggle('active');
  });
}

// Event delegation so Add Bundle works in dynamically loaded Quick Shop modals too
if (!window.__relatedProductsAtcDelegated) {
  window.__relatedProductsAtcDelegated = true;
  document.addEventListener('click', function (event) {
    const related_button = event.target.closest('.js-related-products-trigger');
    if (!related_button) return;
    event.preventDefault();
    AddRelatedProductsToCart(related_button);
  });
}

function resolveRelatedProductSellingPlanId(itemWrapper) {
  if (!itemWrapper) return '';

  const plan30 = itemWrapper.getAttribute('data-selling-plan-id-30') || '';
  const plan90 = itemWrapper.getAttribute('data-selling-plan-id-90') || '';
  const planDefault = itemWrapper.getAttribute('data-selling-plan-id') || plan30 || plan90 || '';
  if (!planDefault && !plan30 && !plan90) return '';

  const activePlan =
    document.querySelector('.card_product_subscription .collapsible_subscription_main.active') ||
    document.querySelector('.collapsible_subscription_main.active');

  if (!activePlan || activePlan.classList.contains('collapsible-button__onetime')) {
    return planDefault || plan30 || plan90 || '';
  }

  const radio = activePlan.querySelector('input.select-plan, input[type="radio"]');
  const subscribeBtn = activePlan.querySelector('.subscribe-button');
  const planLabel = ((radio && radio.getAttribute('data-label')) || '').toLowerCase();
  const sellingPlanName = (
    (subscribeBtn && subscribeBtn.getAttribute('data-selling-plan-name')) ||
    (radio && radio.getAttribute('data-selling-plan-name')) ||
    ''
  ).toLowerCase();

  const isQuarterly = isQuarterlySellingPlan({ planLabel, sellingPlanName });
  const isMonthly = isMonthlySellingPlan({ planLabel, sellingPlanName, isQuarterly });

  if (isQuarterly && plan90) return plan90;
  if (isMonthly && plan30) return plan30;
  return planDefault || plan30 || plan90 || '';
}

async function AddRelatedProductsToCart(related_button) {
  const closest_main_wrapper = related_button.closest('.related-product-section-cart-btn');
  if (!closest_main_wrapper) return;

  const cart = document.querySelector('cart-drawer');
  const itemWrapper = closest_main_wrapper.querySelector('.related_product_variant_id');
  const itemId = itemWrapper ? itemWrapper.getAttribute('value') : '';
  if (!itemId) return;

  related_button.classList.add('custom-loading');

  try {
    const item = {
      id: Number(itemId) || itemId,
      quantity: 1,
    };

    let sellingPlanId = resolveRelatedProductSellingPlanId(itemWrapper);
    if (!sellingPlanId && itemWrapper) {
      const handle = itemWrapper.getAttribute('data-product-handle');
      let info = await fetchProductSubscriptionInfo(handle, itemId);
      if (!info && handle) {
        try {
          const productResponse = await fetch(`${window.Shopify.routes.root}products/${handle}.js`);
          if (productResponse.ok) {
            const relatedProduct = await productResponse.json();
            const variantWithPlan = (relatedProduct.variants || []).find(
              (variant) => variant.selling_plan_allocations && variant.selling_plan_allocations.length
            );
            if (variantWithPlan) {
              info = await fetchProductSubscriptionInfo(handle, variantWithPlan.id);
            }
          }
        } catch (lookupError) {
          console.error('Add Bundle selling plan lookup:', lookupError);
        }
      }
      if (info && info.sellingPlanId) {
        sellingPlanId = String(info.sellingPlanId);
        if (info.variantId) item.id = Number(info.variantId) || info.variantId;
      }
    }
    if (sellingPlanId) {
      const planIdNumber = Number(sellingPlanId);
      item.selling_plan = Number.isNaN(planIdNumber) ? sellingPlanId : planIdNumber;
    }

    if (cart && typeof cart.getSectionsToRender === 'function') {
      item.sections = cart.getSectionsToRender().map((section) => section.section || section.id);
      item.sections_url = window.location.pathname;
    }

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item),
    });
    const data = await response.json();

    if (data.status) {
      console.error('Add Bundle cart error:', data);
      alert(data.description || 'Unable to add bundle to cart');
      return;
    }

    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents(data);
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    } else if (typeof defaultCartDrawerUpdate === 'function') {
      await defaultCartDrawerUpdate(true);
    }

    const quickAddModal = related_button.closest('quick-add-modal');
    if (quickAddModal && typeof quickAddModal.hide === 'function') {
      quickAddModal.hide(true);
    }
  } catch (error) {
    console.error('Add Bundle error:', error);
  } finally {
    related_button.classList.remove('custom-loading');
  }
}

// Add product to cart on klaviyo form submission
window.addEventListener("klaviyoForms", function(e) {
  console.log("Klaviyo Event Fired");
  console.log(e.detail);

  if (
    e.detail.type === "submitOptInCode" &&
    e.detail.formId === "SzQvkh"
  ) {

    const productId = FREE_HYDRATION_PACK_VARIANT_ID;
    const discountCode = "FREEHYDRATION";

    fetch('/cart.js')
      .then((res) => res.json())
      .then(async (cart) => {
        const productIdNum = FREE_HYDRATION_PACK_VARIANT_ID;

        const promoLineExists = cart.items.some(
          (item) => Number(item.variant_id) === productIdNum && lineItemIsFreeHydrationPromotion(item)
        );
        if (promoLineExists) {
          console.log('Free hydration promo already in cart');
          return fetch(`/discount/${discountCode}?redirect=/cart`, {
            method: 'GET',
            credentials: 'same-origin'
          });
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: productId,
                quantity: 1,
                properties: {
                  [FREE_HYDRATION_LINE_PROP]: true,
                },
              },
            ],
          }),
        })
        .then(res => res.json())
        .then(data => {
          defaultCartDrawerUpdate();
          console.log('Product added:', data);
          return fetch(`/discount/${discountCode}?redirect=/cart`, {
            method: 'GET',
            credentials: 'same-origin'
          });
        });
      })
      .then(() => {
        defaultCartDrawerUpdate();
        console.log('Discount applied');
      })
      .catch(err => {
        console.error(err);
      });
  }
});

 
/// show price in add to cart btn
document.addEventListener('DOMContentLoaded', () => {
 window.UpdateCartBtnPrice();
});

window.UpdateCartBtnPrice = function(){
   const subscriptionOptions = document.querySelectorAll('.collapsible-button');
  const collapsibleATC = document.querySelector('.product-form__buttons .collapse_add_button .atc_price');
  if (!subscriptionOptions.length || !collapsibleATC) return;
  subscriptionOptions.forEach((option) => {
    option.addEventListener('click', function () {
      const dataValue = option.getAttribute('data-total-value');
      const subscriptionItem = this.closest('.subscription-item');
      // if (!subscriptionItem) return;
      
      // const priceInner = subscriptionItem.querySelector('.price-inner');
      // if (!priceInner) return;

      // const priceText = priceInner.textContent.trim();
      // if (!priceText) return;
      
      collapsibleATC.textContent = dataValue;
      
      const discountWidget = document.querySelector('.free-shipping-discount-wrapper');
      if (subscriptionItem.classList.contains('one-time')) {
        discountWidget.classList.add('hidden');
      } else {
        discountWidget.classList.remove('hidden');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  function lockPageScroll() {
    document.documentElement.classList.add('recharge-popup-open');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('recharge-popup-open');
  }

  // Desktop Popup
  document.querySelectorAll('.popup_button-wrappr').forEach(function (buttonWrapper) {
    const popupButton = buttonWrapper.querySelector('.popup_button');
    const popupWrapper = buttonWrapper.nextElementSibling;
    const popupClose = popupWrapper?.querySelector('.popup-close-btn');

    if (popupWrapper?.classList.contains('popup-img-wrapper') && popupWrapper.parentElement !== document.body) {
      document.body.appendChild(popupWrapper);
    }

    if (popupButton && popupWrapper?.classList.contains('popup-img-wrapper')) {
      popupButton.addEventListener('click', function () {
        popupWrapper.removeAttribute('hidden');
        popupWrapper.setAttribute('aria-hidden', 'false');
        popupWrapper.classList.add('open-popup');
        lockPageScroll();
      });
    }

    if (popupClose && popupWrapper?.classList.contains('popup-img-wrapper')) {
      popupClose.addEventListener('click', function () {
        popupWrapper.classList.remove('open-popup');
        popupWrapper.setAttribute('hidden', '');
        popupWrapper.setAttribute('aria-hidden', 'true');
        unlockPageScroll();
      });
    }
  });

  // Mobile Popup
  document.querySelectorAll('.popup_button-wrappr-mobile').forEach(function (buttonWrapper) {
    const popupButton = buttonWrapper.querySelector('.popup_button-mobile');
    const popupWrapper = buttonWrapper.nextElementSibling;
    const popupClose = popupWrapper?.querySelector('.popup-close-btn-mobile');

    if (popupWrapper?.classList.contains('popup-img-wrapper-mobile') && popupWrapper.parentElement !== document.body) {
      document.body.appendChild(popupWrapper);
    }

    if (popupButton && popupWrapper?.classList.contains('popup-img-wrapper-mobile')) {
      popupButton.addEventListener('click', function () {
        popupWrapper.removeAttribute('hidden');
        popupWrapper.setAttribute('aria-hidden', 'false');
        popupWrapper.classList.add('open-popup');
        lockPageScroll();
      });
    }

    if (popupClose && popupWrapper?.classList.contains('popup-img-wrapper-mobile')) {
      popupClose.addEventListener('click', function () {
        popupWrapper.classList.remove('open-popup');
        popupWrapper.setAttribute('hidden', '');
        popupWrapper.setAttribute('aria-hidden', 'true');
        unlockPageScroll();
      });
    }
  });
});


const categoryBadges = document.querySelector('.category-badges');

if (categoryBadges) {
  const STICKY_TOP_OFFSET = 100;
  let isSticky = false;
  let spacer = null;

  function setCategoryBadgesSticky(shouldStick) {
    if (shouldStick === isSticky) return;

    if (shouldStick) {
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'category-badges-sticky-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        categoryBadges.insertAdjacentElement('afterend', spacer);
      }
      spacer.style.height = categoryBadges.offsetHeight + 'px';
      categoryBadges.classList.add('sticky');
      spacer.style.height = categoryBadges.offsetHeight + 'px';
      isSticky = true;
    } else {
      categoryBadges.classList.remove('sticky');
      if (spacer) {
        spacer.style.height = '0px';
      }
      isSticky = false;
    }
  }

  const sentinel = document.createElement('div');
  sentinel.className = 'category-badges-sticky-sentinel';
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'height:1px;width:100%;pointer-events:none;';
  categoryBadges.insertAdjacentElement('beforebegin', sentinel);

  const stickyObserver = new IntersectionObserver(
    function (entries) {
      const entry = entries[0];
      if (!entry) return;
      setCategoryBadgesSticky(!entry.isIntersecting);
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '-' + STICKY_TOP_OFFSET + 'px 0px 0px 0px',
    }
  );

  stickyObserver.observe(sentinel);

  function syncCategoryBadgesSpacerHeight() {
    if (isSticky && spacer) {
      spacer.style.height = categoryBadges.offsetHeight + 'px';
    }
  }

  window.addEventListener('resize', syncCategoryBadgesSpacerHeight, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    const badgesResizeObserver = new ResizeObserver(syncCategoryBadgesSpacerHeight);
    badgesResizeObserver.observe(categoryBadges);
  }
}

function updateStickyHeight() {
  var countdownSticky = document.querySelector('.countdown_sticky');
  var stickyHeader = document.querySelector('.shopify-section-header-sticky');

  if (!countdownSticky) return;

  var countdownHeight = countdownSticky.offsetHeight;
  var headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;

  document.documentElement.style.setProperty(
    '--countdown-height',
    countdownHeight + 'px'
  );

  document.documentElement.style.setProperty(
    '--header-height',
    headerHeight + 'px'
  );
}

updateStickyHeight();

window.addEventListener('resize', updateStickyHeight);

if (!window.__stickyAtcInit) {
    window.__stickyAtcInit = true;

    var initStickyAtc = function () {
      var root = document.querySelector('[data-sticky-atc]');
      if (!root) return;

      var mq = window.matchMedia('(max-width: 749px)');
      var typeEl = root.querySelector('[data-sticky-atc-type]');
      var labelEl = root.querySelector('[data-sticky-atc-label]');
      var priceEl = root.querySelector('[data-sticky-atc-price]');
      var addBtn = root.querySelector('[data-sticky-atc-add]');
      var lastShow = null;
      var ticking = false;

      if (root.parentElement !== document.body) {
        document.body.appendChild(root);
      }

      var isUsable = function (el) {
        if (!el) return false;
        var node = el;
        while (node && node !== document.body) {
          var style = window.getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden') return false;
          node = node.parentElement;
        }
        var rect = el.getBoundingClientRect();
        return rect.width > 0 || rect.height > 0;
      };

      var pickFirst = function (selector) {
        var nodes = document.querySelectorAll(selector);
        for (var i = 0; i < nodes.length; i++) {
          if (isUsable(nodes[i])) return nodes[i];
        }
        return null;
      };

      var findUpsellTrigger = function () {
        return (
          pickFirst('.related_product.mobile[data-sticky-atc-bundle]') ||
          pickFirst('.related_product.mobile') ||
          pickFirst('.related_product.mySwiper-related_product') ||
          pickFirst('[data-sticky-atc-bundle]') ||
          pickFirst('.related-product-section')
        );
      };

      var findMainAtc = function () {
        return (
          pickFirst('.product-body-right .collapsible-add-button') ||
          pickFirst('.card_product_subscription .collapsible-add-button') ||
          pickFirst('.widget_button .collapsible-add-button')
        );
      };

      var hasScrolledPast = function (el) {
        return el.getBoundingClientRect().bottom <= 0;
      };

      var setVisible = function (visible) {
        var show = !!(visible && mq.matches);
        if (show === lastShow) return;
        lastShow = show;
        root.classList.toggle('is-visible', show);
        if (show) {
          root.removeAttribute('hidden');
          root.setAttribute('aria-hidden', 'false');
        } else {
          root.setAttribute('hidden', '');
          root.setAttribute('aria-hidden', 'true');
        }
      };

      var syncFromPage = function () {
        var active = document.querySelector('.widget_button .collapsible_subscription_main.active');
        if (!active) return;

        var isOneTime = active.classList.contains('collapsible-button__onetime');
        root.classList.toggle('is-onetime', isOneTime);

        if (typeEl) {
          typeEl.textContent = isOneTime
            ? root.getAttribute('data-label-onetime')
            : root.getAttribute('data-label-subscription');
        }

        var item = active.closest('.subscription-item');
        var totalEl = item ? item.querySelector('.total_month_saving') : null;
        if (!totalEl) {
          totalEl = document.querySelector('.subscription-item:has(.collapsible-button.active) .total_month_saving');
        }

        if (totalEl) {
          var labelSpan = totalEl.querySelector('span');
          var priceSpan = totalEl.querySelector('.price-inner') || totalEl.querySelectorAll('span')[1];
          if (labelEl && labelSpan) labelEl.textContent = labelSpan.textContent.trim();
          if (priceEl && priceSpan) priceEl.textContent = priceSpan.textContent.trim();
          return;
        }

        if (labelEl) {
          var savingText = active.getAttribute('data-saving-text');
          if (savingText) labelEl.textContent = savingText;
        }
        if (priceEl) {
          var totalValue = active.getAttribute('data-total-value');
          if (totalValue) priceEl.textContent = totalValue;
        }
      };

      var check = function () {
        if (!mq.matches) {
          setVisible(false);
          return;
        }
        var upsell = findUpsellTrigger();
        if (upsell) {
          setVisible(hasScrolledPast(upsell));
          return;
        }
        var mainAtc = findMainAtc();
        if (!mainAtc) {
          setVisible(false);
          return;
        }
        setVisible(hasScrolledPast(mainAtc));
      };

      var onScrollOrResize = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          check();
        });
      };

      if (addBtn) {
        addBtn.addEventListener('click', function (event) {
          event.preventDefault();
          var wrap = document.querySelector('.widget_button .collapsible-add-button');
          if (!wrap) return;
          var inner = wrap.querySelector('button');
          if (inner && (inner.disabled || inner.classList.contains('disabled') || inner.classList.contains('subscribe-button-soldout'))) {
            return;
          }
          addBtn.classList.add('custom-loading');
          wrap.click();
          window.setTimeout(function () {
            addBtn.classList.remove('custom-loading');
          }, 1000);
        });
      }

      document.addEventListener('click', function (event) {
        if (
          event.target.closest('.widget_button .collapsible-button') ||
          event.target.closest('.qty-plus') ||
          event.target.closest('.qty-minus')
        ) {
          window.setTimeout(syncFromPage, 50);
        }
      });

      window.addEventListener('scroll', onScrollOrResize, { passive: true, capture: true });
      window.addEventListener('resize', onScrollOrResize, { passive: true });
      document.addEventListener('scroll', onScrollOrResize, { passive: true, capture: true });
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onScrollOrResize);
        window.visualViewport.addEventListener('scroll', onScrollOrResize);
      }
      if (mq.addEventListener) {
        mq.addEventListener('change', check);
      } else if (mq.addListener) {
        mq.addListener(check);
      }

      syncFromPage();
      check();
      window.setTimeout(check, 250);
      window.setTimeout(check, 1000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyAtc);
    } else {
      initStickyAtc();
    }
  }


  document.addEventListener('DOMContentLoaded', function () {
    const countdownTimer = document.querySelector('.countdown-timer');

    if (countdownTimer) {
      document.body.classList.add('add-countdown-timer');
    } else {
      document.body.classList.remove('add-countdown-timer');
    }
  });


window.UpdateReadLessBtn = function () {
  if (window.__readMoreBtnDelegated) return;
  window.__readMoreBtnDelegated = true;
  document.addEventListener('click', function (event) {
      const btn = event.target.closest('.read-more-btn');
      if (!btn) return;

      const textElement = btn.closest('.product-information-details');
      if (!textElement) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const isExpanded = textElement.classList.toggle('expanded');
      btn.textContent = isExpanded ? 'Less...' : 'More...';
      btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    },
    true
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.UpdateReadLessBtn);
} else {
  window.UpdateReadLessBtn();
}
